/**
 * Prevent text wrapping in top-level nav items.
 */
const fixWidows = () => {
	const items = document.querySelectorAll<HTMLElement>(
		'[data-menu-content="main-nav"] > li > [data-text]'
	)
	items.forEach( item => {
		item.style.whiteSpace = 'nowrap'
	} )
}

export default fixWidows
